import React, { useState, useEffect } from 'react';

const PDFViewer = ({ documentId, onClose }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        if (documentId) {
            loadPDF();
        }
    }, [documentId]);

    const getAuthHeaders = () => {
        const token = localStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
        };
    };

    const loadPDF = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${backendUrl}/api/pdf/${documentId}/download`, {
                headers: getAuthHeaders(),
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                setPdfUrl(url);
                setError(null);
            } else {
                setError('Erreur lors du chargement du PDF');
            }
        } catch (error) {
            console.error('Erreur lors du chargement du PDF:', error);
            setError('Erreur lors du chargement du PDF');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (pdfUrl) {
            window.URL.revokeObjectURL(pdfUrl);
        }
        if (onClose) {
            onClose();
        }
    };

    if (loading) {
        return (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 shadow-lg">
                    <div className="flex items-center space-x-2">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                        <span>Chargement du PDF...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 shadow-lg">
                    <div className="text-center">
                        <div className="text-red-600 mb-4">{error}</div>
                        <button
                            onClick={handleClose}
                            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                        >
                            Fermer
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 z-50">
            <div className="h-full flex flex-col">
                {/* Header with controls */}
                <div className="bg-white shadow-md px-4 py-3 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-900">
                        Visionneuse PDF
                    </h3>
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => window.open(pdfUrl, '_blank')}
                            className="px-3 py-1 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700"
                        >
                            Ouvrir dans nouvel onglet
                        </button>
                        <button
                            onClick={handleClose}
                            className="px-3 py-1 bg-gray-600 text-white text-sm rounded-lg hover:bg-gray-700"
                        >
                            Fermer
                        </button>
                    </div>
                </div>

                {/* PDF Content */}
                <div className="flex-1 bg-gray-100 p-4">
                    {pdfUrl ? (
                        <iframe
                            src={pdfUrl}
                            className="w-full h-full border-0 rounded-lg shadow-lg"
                            title="Document PDF"
                        />
                    ) : (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-gray-500">Impossible d'afficher le PDF</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PDFViewer;